import { Controller } from "@hotwired/stimulus";

let lastAnnouncedPercent = null;

export function resetProgressAnnouncerStateForTests() {
  lastAnnouncedPercent = null;
}

export function lastAnnouncedProgressPercentForTests() {
  return lastAnnouncedPercent;
}

// Connects to data-controller="case-experience--progress-announcer"
// Announces case completion progress changes via a nearby status live region.
// Does not put aria-live on the progressbar itself.
export default class extends Controller {
  static targets = ["status", "value"];

  static values = {
    percent: Number,
  };

  percentValueChanged() {
    const percent = this.roundedPercent();
    this.paint(percent);

    if (!this.isExposedToAssistiveTech()) return;

    if (lastAnnouncedPercent === null) {
      lastAnnouncedPercent = percent;
      return;
    }

    if (lastAnnouncedPercent === percent) return;

    lastAnnouncedPercent = percent;
    this.announce(percent);
  }

  paint(percent) {
    this.element.querySelector('[role="progressbar"]')?.setAttribute("aria-valuenow", percent);
    const fill = this.element.querySelector(".railsui-progress__fill");
    if (fill) fill.style.width = `${percent}%`;
    if (this.hasValueTarget) this.valueTarget.textContent = `${percent}%`;
  }

  roundedPercent() {
    return Number.isFinite(this.percentValue) ? Math.round(this.percentValue) : 0;
  }

  isExposedToAssistiveTech() {
    let el = this.element;
    while (el && el !== document.documentElement) {
      const style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden") return false;
      el = el.parentElement;
    }
    return true;
  }

  announce(percent) {
    if (!this.hasStatusTarget) return;

    const message = `${percent}% of the case is completed`;
    this.statusTarget.textContent = "";
    requestAnimationFrame(() => {
      this.statusTarget.textContent = message;
    });
  }
}
